export default "__VITE_ASSET__BagIV9Tc__"